import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from 'app/shared/services/authentication.service';
import { NavigationService } from 'app/shared/services/navigation.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageGlobalConfigurationGuard implements CanActivate {

  constructor(private authService: AuthenticationService, private navigation: NavigationService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.navigation.redirectToHomeIfNotAllowed(() => this.authService.canManageGlobalConfiguration());
  }
}
